/*
 * @Description: 项目配置
 * @Date: 2021-03-22 00:21:31
 */

export const TOKEN_KEY = 'authentication';

export const REQUEST_PATH = '';

export const REQUEST_DOMAIN = process.env.VUE_APP_PROXY;

export const XCX_PATH = process.env.VUE_APP_XCX;

export const FILE_VIEW_URL =
  'https://oss.myxrk.com/myxrk-v2/front-end/html/file-view/index.html';

export const SUN_WEB_URL = process.env.VUE_APP_SUN_URL;

export const BI_URL =
  process.env.VUE_APP_BI_DOMAIN + process.env.VUE_APP_BI_PATH;

export const REPORT_URL =
  process.env.VUE_APP_BI_DOMAIN + process.env.VUE_APP_REPORT_PATH;

export const QQ_MAP_KEY = 'ZXVBZ-4333V-RT3PJ-UQYHY-SIBIQ-BHFTU';
